/**
 * t374u: branding calls, for the web and iOS apps. Kept beside the model rather than in ApiClient, so they need only
 * the client's generic request().
 */
import type { BrandingSettings, WorkspaceBranding } from './branding';

interface Requester {
  request<R>(method: string, path: string, body?: unknown, query?: Record<string, string | number | boolean | undefined | null>): Promise<R>;
}

export interface UploadedBrandAsset { id: string; url: string; content_type: string; size: number }

export const brandingApi = (api: Requester) => ({
  /** Before sign-in: the company this address belongs to (The Hub's own look when none). */
  forHost: (host: string, slug?: string | null) => api.request<WorkspaceBranding>('GET', '/branding', undefined, { host, slug: slug ?? undefined }),
  get: (ws: string) => api.request<WorkspaceBranding>('GET', `/workspaces/${ws}/branding`),
  /** Owners and admins. Only the fields given change; null clears one. */
  save: (ws: string, patch: BrandingSettings) => api.request<WorkspaceBranding>('PUT', `/workspaces/${ws}/branding`, patch),
  /** Base64 file contents; returns the id to save in a logo slot. */
  upload: (ws: string, file: { content_type: string; data: string }) => api.request<UploadedBrandAsset>('POST', `/workspaces/${ws}/branding/assets`, file),
});
